import { SvgIconProps } from './icon-props';

export default function Add({ height = 32, width = 33, fill = 'black' }: SvgIconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 32 33"
			fill="none"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M16 31.7C24.3947 31.7 31.2 24.8947 31.2 16.5C31.2 8.10527 24.3947 1.3 16 1.3C7.60527 1.3 0.8 8.10527 0.8 16.5C0.8 24.8947 7.60527 31.7 16 31.7ZM16 32.5C7.16344 32.5 0 25.3366 0 16.5C0 7.66344 7.16344 0.5 16 0.5C24.8366 0.5 32 7.66344 32 16.5C32 25.3366 24.8366 32.5 16 32.5ZM16.8107 15.908H20.2987V16.996H16.8107V20.5H15.7227V16.996H12.2347V15.908H15.7227V12.404H16.8107V15.908Z"
				fill={fill}
			/>
		</svg>
	);
}
